// extracted by mini-css-extract-plugin
export default {"font-renta":"MassProducts_font-renta__xWzRP","massProducts":"MassProducts_massProducts__X-Vsj","toolbar":"MassProducts_toolbar__rEadH"};